import useDialog from "@Features/dialog/hooks/useDialog";
import {useEffect, useState} from "react";
import AvailablePassengerClassType from "@CheckOrder/features/classPicker/types/AvailablePassengerClass.type";

/**
 * Handles passenger class select modal
 */
export default function useAdditionalPassengerClassSelectModal() {
    const {dialogRef, openModal, closeModal: closePassengerClassSelectModal} = useDialog()
    const [newlySelectedPassengerClass, setNewlySelectedPassengerClass] = useState<AvailablePassengerClassType>(undefined)

    useEffect(() => {
        if (newlySelectedPassengerClass) {
            openModal()
        }
    }, [newlySelectedPassengerClass]);

    const closeModal = () => {
        closePassengerClassSelectModal()
        setNewlySelectedPassengerClass(undefined)
    }

    return {
        dialogRef,
        closeModal,
        newlySelectedPassengerClass,
        setNewlySelectedPassengerClass,
    }
}